/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { makeStyles, TableCell, Tooltip } from '@material-ui/core';
import React, { useState } from 'react';
import { isOverflown } from 'shared/utils/uxUtils';
import { Trans } from 'react-i18next';
import classnames from 'classnames';

const useStyles = makeStyles(() => ({
  tooltip: {
    fontSize: '1rem',
    padding: '0.375rem 1.5rem',
    lineHeight: '2rem',
  },
  ellipsis: {
    overflow: 'hidden',
    whiteSpace: 'noWrap',
    textOverflow: 'ellipsis',
  },
  hasChips: {
    padding: 0,
    '& .MuiChip-root': {
      marginLeft: '0.25rem',
      '&:first-child': {
        marginLeft: '1rem',
      },
      '&:last-child': {
        marginRight: '1rem',
      },
    },
  },
}));

const BodyCell = (props) => {
  const { itemTableCell, itemIndex, itemCellIndex, hasChips } = props;
  const { tooltip } = itemTableCell;

  const classes = useStyles();
  const [showTooltip, setShowTooltip] = useState([null, null]);

  const onMouseEnterCallback = (event) => {
    if (isOverflown(event.target)) {
      setShowTooltip([itemIndex, itemCellIndex]);
    } else {
      setShowTooltip([null, null]);
    }
  };

  const openTooltip = showTooltip[0] === itemIndex && showTooltip[1] === itemCellIndex;

  return (
    <Tooltip
      title={tooltip ? <Trans i18nKey={tooltip} /> : itemTableCell.value}
      open={openTooltip}
      classes={{ tooltip: classes.tooltip }}
      className={classnames(hasChips && classes.hasChips)}
      key={itemTableCell.field}
      placement="top"
      data-testid={`tooltip-${showTooltip[0]}-${showTooltip[1]}`}
    >
      <TableCell
        className={classes.ellipsis}
        onMouseLeave={() => {
          setShowTooltip([null, null]);
        }}
        onMouseEnter={event => onMouseEnterCallback(event)}
      >
        {itemTableCell.value ? itemTableCell.value : ''}
      </TableCell>
    </Tooltip>
  );
};

export default BodyCell;
